import React, {useState} from 'react';
import {IconEllipsisHorizontal} from "../../../../components/icons";
import {useNavigate} from "react-router-dom";

const DossierStatutList = ({displayMax = 8, dossierStatut = []}: { displayMax?: number, dossierStatut?: any }) => {
  const navigate = useNavigate();
  const [displayStatuts, setDisplayStatuts] = useState<boolean>(false);

  const DossierGroup = ({total = 0, title = ''}: { total?: number, title?: string }) => {
    return (
      <div
        onClick={() => navigate('/dossiers', {state: {isSecondaire: false, currentPage: 1, statut: title}, replace: true})}
        className="border bg-white flex items-center shadow rounded-lg hover:cursor-pointer hover:shadow-md p-2"
      >
        <div className="flex items-center gap-2">
          <span className="rounded-md text-xs font-medium text-white bg-gray-500 w-9 h-9 p-3 flex justify-center items-center">
            {total}
          </span>
          <p className="text-sm text-gray-500">{title}</p>
        </div>
      </div>
    );
  };

  if (dossierStatut?.length === 0) return null;

  return (
    <>
      <div className="px-2 pb-2 mx-2 mb-2 min-h-[190px]">
        <div className="grid grid-cols-3 gap-2">
          {(dossierStatut) && (dossierStatut?.map((dossierStat, key: number) =>
            (key >= displayMax) ? null : <DossierGroup key={key} total={dossierStat?.total} title={dossierStat?.statut}/>
          ))}
        </div>
      </div>
      <div className="relative"/>
      {(dossierStatut?.length > displayMax) && (
        <div
          onClick={() => setDisplayStatuts(!displayStatuts)}
          className="absolute -bottom-1 right-1 flex items-center justify-center rounded-lg hover:cursor-pointer"
        >
          <IconEllipsisHorizontal className="w-6 h-6 text-gray-400"/>
        </div>
      )}
      {(displayStatuts) && (
        <div className="absolute right-0 mt-2 min-w-[230px]">
          <div className="bg-white shadow-md border rounded-lg border-gray-100 flex-inline space-y-2 p-2">
            {(dossierStatut) && (dossierStatut?.map((dossierStat, key: number) =>
              (key >= displayMax) ? <DossierGroup key={key} total={dossierStat?.total} title={dossierStat?.statut}/> : null
            ))}
          </div>
        </div>
      )}
    </>
  );
}

export default DossierStatutList;